import script from "./HomeCreditPhone.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeCreditPhone.vue?vue&type=script&lang=ts&setup=true"

import "./HomeCreditPhone.vue?vue&type=style&index=0&id=21ba85aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21ba85aa"]])

export default __exports__